import { FieldFunctionOptions, FieldMergeFunction } from '@apollo/client'

export const customFieldMerger: FieldMergeFunction<
   any,
   any,
   FieldFunctionOptions<Record<string, any>, Record<string, any>>
> = (existing, incoming, { variables }) => {
   const offset = variables?.params.pagination.offset
   // NOTE: Slicing is necessary because the existing data is immutable, and frozen in development.
   const merged = existing && offset ? existing.slice(0) : []

   for (let i = 0; i < incoming.length; ++i) {
      merged[offset + i] = incoming[i]
   }
   return merged
}
